// src/AppRoutes.js
import React, { useContext } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import ForgotPassword from './components/ForgotPassword';

import TechSubmit from './components/TechSubmit'
import TechsubmitRegistrationPage from './components/TechsubmitRegistrationPage'
import TechsubmitRegistrationPage_new from './components/TechsubmitRegistrationPage_new'

import PaymentSuccess from './components/PaymentSucess'
import PaymentCancel from './components/PaymentCancel'

import CheckInPage from './components/CheckInPage'

import DropboxApply from './components/DropboxApply'

//panditpurohit
import PPMainPage from './components/PunditPurohit/pages/PPmainpage'
import PoojasPage  from './components/PunditPurohit/pages/PoojasPage'
import PoojaItemsPage  from './components/PunditPurohit/pages/PoojaItemsPage'
import PunditsPage  from './components/PunditPurohit/pages/PunditsPage'
import PoojaDetails  from './components/PunditPurohit/pages/PoojaDetails'
import PoojaLibrary  from './components/PunditPurohit/pages/PoojaLibrary'
import AddressBook  from './components/PunditPurohit/pages/AddressBook'
import Profile  from './components/PunditPurohit/pages/Profile'
import PoojaLogin from './components/PunditPurohit/pages/PoojaLogin';
import { CartProvider } from './components/PunditPurohit/context/CartContext';
import PunditPurohitLayout from './components/PunditPurohit/layout/PunditPurohitLayout';
import CartDrawer from './components/PunditPurohit/components/CartDrawer'

import AboutLegal from './components/AboutLegal'
import ViewOrders from './components/PunditPurohit/pages/ViewOrders'
import PoojaPaymentSuccess from './components/PunditPurohit/pages/PoojaPaymentSuccess'
import PoojaPaymentCancel from './components/PunditPurohit/pages/PoojaPaymentCancel'

//2.0
import UdyogConnect from './components/udyogconnect2.0';

const LegacyIndustryRedirect = () => {
  const { name } = useParams();
  return <Navigate to={`/2.0/industry/${name}`} replace />;
};

const AppRoutes = () => {
  const { loading } = useContext(AuthContext);

  if (loading) return <div>Loading...</div>;

  return (
    <>
    <Routes>
        <Route path="/login" element={<Navigate to="/2.0/login" replace />} />
        <Route path="/" element={<Navigate to="/2.0" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
         <Route path="/about-legal-udyogconnect" element={<AboutLegal />} />
        <Route path='techsummit2025' element={<TechSubmit/>}/>
        <Route path='techsummit2025_registration' element={<TechsubmitRegistrationPage_new/>}/>
        <Route path='techsummit2025_registration/payment-success' element={<PaymentSuccess/>}/>
        <Route path='techsummit2025_registration/payment-cancel' element={<PaymentCancel/>}/>
        <Route path='techsummit2025_registration/usercheckin' element={<CheckInPage/>}/>
        <Route path='techsummit2025/dropbox' element={<DropboxApply/>}/>    
        {/* Legacy UdyogConnect routes */}
        <Route path="home" element={<Navigate to="/2.0" replace />} />
        <Route path="about" element={<Navigate to="/2.0/about" replace />} />
        <Route path="companies" element={<Navigate to="/2.0/companies" replace />} />
        <Route path="request" element={<Navigate to="/2.0/request" replace />} />
        <Route path="admin" element={<Navigate to="/2.0/admin" replace />} />
        <Route path="profile-update" element={<Navigate to="/2.0/profile-update" replace />} />
        <Route path="opportunities" element={<Navigate to="/2.0/opportunities" replace />} />
        <Route path="industry/:name" element={<LegacyIndustryRedirect />} />
        <Route path="updatepassword" element={<Navigate to="/2.0/updatepassword" replace />} />
        <Route path="events" element={<Navigate to="/2.0/events" replace />} />
        <Route path="techsummit-register" element={<TechsubmitRegistrationPage />} />
        <Route path="udyog-login" element={<PoojaLogin />} />
        <Route path="udyog-signup" element={<PoojaLogin initialMode="signup" />} />
        <Route path="uc" element={<CartProvider>
                                          <CartDrawer />
                                          <PunditPurohitLayout />
                                        </CartProvider>}>
          <Route path="panditpurshothit" element={<PPMainPage />} />
          <Route path="ViewOrders" element={<ViewOrders />} />
          <Route path="pooja-payment-success" element={<PoojaPaymentSuccess />} />
          <Route path="pooja-payment-cancel" element={<PoojaPaymentCancel />} />
          <Route path="poojas" element={<PoojasPage />} />
          <Route path="pooja-items" element={<PoojaItemsPage />} />
          <Route path="pundits" element={<PunditsPage />} />
          <Route path="pooja-details/:id" element={<PoojaDetails />} />         
          <Route path="pooja-library" element={<PoojaLibrary />} />
          {/* New Profile & Address Routes */}
          <Route path="profile" element={<Profile />} />
          <Route path="address-book" element={<AddressBook />} />
        </Route>
        <Route path="/2.0/*" element={<UdyogConnect />} />
        <Route path="*" element={<Navigate to="/2.0" replace />} />
    </Routes>
        
    
    </>
    
  );
};

export default AppRoutes;
